import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { TaskDetailsTabId } from "@jugl-web/domain-resources/tasks";
import { TasksBoardId } from "@jugl-web/rest-api/tasks";
import { NavigateToPage } from "@web-src/modules/navigation/components/NavigateToPage";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const TaskDetails = lazy(() => import("@web-src/pages/TaskDetails"));
const TaskTemplatesFoldersPage = lazy(
  () => import("@web-src/pages/TaskTemplateFolders")
);
const TaskTemplatesPage = lazy(() => import("@web-src/pages/TaskTemplates"));
const TasksPage = lazy(() => import("@web-src/pages/Tasks"));
const TasksArchive = lazy(() => import("@web-src/pages/TasksArchive"));

export type TasksPagesNavigationParams = {
  tasksEntryPoint: PageNavParams;
  tasksTasks: PageNavParams<{ boardId: TasksBoardId }>;
  tasksTemplates: PageNavParams;
  tasksTemplatesFolder: PageNavParams<{ folderId: string }>;
  taskDetails: PageNavParams<{ taskId: string }, { tab: TaskDetailsTabId }>;
  tasksArchive: PageNavParams;
};

export const tasksPagesNavigationConfig: ModulePagesConfig<TasksPagesNavigationParams> =
  {
    tasksEntryPoint: {
      element: (
        <NavigateToPage page="tasksTasks" pathParams={{ boardId: "my" }} />
      ),
      path: "tasks",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.tasks,
    },
    tasksTasks: {
      element: <TasksPage />,
      path: "tasks/board/:boardId",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.tasks,
    },
    tasksTemplates: {
      element: <TaskTemplatesFoldersPage />,
      path: "tasks/templates",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.tasks,
    },
    tasksTemplatesFolder: {
      element: <TaskTemplatesPage />,
      path: "tasks/templates/:folderId",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.tasks,
    },
    taskDetails: {
      element: <TaskDetails />,
      path: "tasks/details/:taskId",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.tasks,
    },
    tasksArchive: {
      element: <TasksArchive />,
      path: "tasks/archive",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.tasks,
    },
  };
